// Single source of truth for "which deployment is this bundle running in".
//
// This resolver FAILS CLOSED: an unset or unrecognised VUE_APP_DEPLOY_ENV
// resolves to production. Every non-production-only behaviour in the app is
// something an investor must never see — the socket idle guard disconnects
// live notifications and shows a "dev session" notice, and the dev socket
// path sends credentials to a different origin. Defaulting those ON when we
// are merely unsure is the wrong direction for a regulated investor app, so
// the default is the safe one and a non-production build has to say so.
//
// Recognising environments from an allowlist (rather than testing for the
// single string "production") means a build path that forgets the variable,
// or a future environment name nobody remembered to handle here, degrades to
// production behaviour instead of silently switching dev behaviour on in
// front of customers.
//
// `window.location.hostname` is consulted only when the variable is absent,
// mirroring the fallback already used in main.js, so a build that loses the
// variable still behaves correctly when it is actually served on a known
// non-production host.

export const NON_PRODUCTION_DEPLOY_ENVS = Object.freeze([
  "development",
  "dev",
  "local",
  "test",
  "ci",
]);

export const NON_PRODUCTION_HOSTNAMES = Object.freeze([
  "dev.invown.com",
  "www.dev.invown.com",
  "localhost",
  "127.0.0.1",
]);

function configuredDeployEnv() {
  return String(
    process.env.VUE_APP_DEPLOY_ENV || process.env.VUE_APP_ENVIRONMENT || ""
  )
    .trim()
    .toLowerCase();
}

function hostnameSuggestsNonProduction(windowRef) {
  const target =
    windowRef || (typeof window === "undefined" ? null : window);
  const hostname = target && target.location && target.location.hostname;
  if (!hostname) {
    return false;
  }
  return NON_PRODUCTION_HOSTNAMES.includes(String(hostname).toLowerCase());
}

/**
 * True only when this bundle is positively known to be non-production.
 *
 * Unset, empty, or unrecognised values return false so that
 * non-production-only behaviour stays off unless we are sure.
 */
export function isNonProductionBuild(options = {}) {
  const configured = configuredDeployEnv();
  if (configured) {
    return NON_PRODUCTION_DEPLOY_ENVS.includes(configured);
  }
  return hostnameSuggestsNonProduction(options.windowRef);
}

/** Inverse of isNonProductionBuild — the fail-closed default. */
export function isProductionBuild(options = {}) {
  return !isNonProductionBuild(options);
}
